import { ThemeEvents } from '@theme/events';
const { dialogOpen } = ThemeEvents;

// 生年月日の追加
document.addEventListener('DOMContentLoaded', function() {
  // 会員登録フォーム（create_customer）内の生年月日UIを初期化
  document.querySelectorAll('form[action="/account"]').forEach(function(form) {
    // 生年月日ブロックがないフォームはスキップ
    var birthdayWrap = form.querySelector('.customer-birthday');
    if (!birthdayWrap) return;
    // 保存先(hidden)を用意：customer[note] 1本にまとめて保存
    var noteHidden = form.querySelector('input[name="customer[note][birthday]"');
    if (!noteHidden) {
      noteHidden = document.createElement('input');
      noteHidden.type = 'hidden';
      noteHidden.name = 'customer[note]';
      noteHidden.className = 'birthdaynote';
      form.appendChild(noteHidden);
    }
  });
});

function initSwiper() {
  var root = document.querySelector('.qv-swiper');
  if (!root || !window.Swiper) return;
  var main = new Swiper(root.querySelector('.main-qv-swiper'), {
    initialSlide: 0,
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    autoHeight: true,
    speed: 400,
    allowTouchMove: false,
    pagination: false,
    navigation: {
      nextEl: root.querySelector('.swiper-button-next'),
      prevEl: root.querySelector('.swiper-button-prev'),
    },
  });
}

// 商品一覧：クイックビューの再入荷通知
document.addEventListener('DOMContentLoaded', function() {
  const quickView = document.querySelector('#hdt-quick-view-modal');
  if(document.querySelectorAll('button[area-label="Quick view"]').length < 0 || !quickView) return; // クイックビューが存在しない場合は処理を終了

  // クイックビューが開いたときの処理
  quickView.addEventListener(dialogOpen, () => {
    // クイックビューのスワイパーを初期化
    initSwiper();

    const variantRadios = quickView.querySelectorAll('.hdt-product-form__values input[type="radio"]');
    const form = quickView.querySelector('.hdt-main-product-form');
    const submitButton = form?.querySelector('.hdt-product-form__submit');
    const buyNowButton = form?.querySelector('.shopify-payment-button__button'); // 今すぐ購入ボタン

    const text = submitButton?.textContent.trim().toLowerCase();
    console.log(text);
    let isPreOrder = false;
    if (text.includes('pre-order') || text.includes('preorder')) {
      isPreOrder = true;
    }

    if(!submitButton && !isPreOrder) return; // 購入ボタンが存在しない場合は処理を終了
    if(submitButton?.dataset.noNotify) return; //no-notifyがTrueの場合は処理を終了

    // 再入荷通知メッセージの更新処理
    const updateRestockMessage = hasVariant => {
      // 既存のメッセージがあれば削除
      form.querySelector('.hdt-form__message-wrapper.hdt-form-message--restock')?.remove();

      setTimeout(() => {
        if(!submitButton.disabled) return; // 購入ボタンが有効な場合（在庫がある場合）は処理を終了

        const url = quickView.querySelector('.hdt-product__title a')?.href + '?restock=open' + (hasVariant ? `&variant=${form.elements['id']?.value}` : '');
        let contentText = '再入荷通知を受け取る';
        if(submitButton?.dataset.preOrder) {
          contentText='販売開始の告知を受け取る';
        }
        // URLにenが含まれたらcontentTextを英語に変換
        if(url.includes('/en/')) {
          contentText = 'Notify me if back in stock';
          if(submitButton?.dataset.preOrder) {
            contentText = 'Notify me when it\'s available';
          }
        }
        const content = `<div class="hdt-restock-message-qv"><a href="${url}">${contentText}</a></div>`;
        const message = document.createElement('div');
        message.classList.add('hdt-form__message-wrapper', 'hdt-form-message--restock');
        message.innerHTML = content;
        message.style.marginTop = hasVariant ? '' : '1.5rem';
        form.appendChild(message); // メッセージを挿入

        // 今すぐ購入ボタンを無効化（初期のみdisabledが付与されない不具合対処）
        if(buyNowButton) buyNowButton.disabled = true;
      }, 0);
    }

    if(variantRadios.length === 0) {
      // バリアントが存在しない場合
      updateRestockMessage(false);
    } else {
      // バリアントが存在する場合
      variantRadios.forEach(variantRadio => {
        variantRadio.addEventListener('change', () => {
          if(!variantRadio.checked) return;
          updateRestockMessage(true);
        });
      });
    }
  });
});

// 商品詳細：再入荷モーダル表示
document.addEventListener('DOMContentLoaded', function() {
  if(document.querySelectorAll('button[area-label="Quick view"]').length < 0) return; // quick-viewボタンが存在しない場合は処理を終了

  const params = new URLSearchParams(window.location.search);
  const targetVariant = params.get('variant');
  const restockOpenFlag = params.get('restock') === 'open';
  if(!restockOpenFlag) return; // 対象のバリアントが無効か、再入荷通知モーダルを開くフラグがない場合は処理を終了

  const restockApp = document.querySelector('#restock-notice-btn');
  if(!restockApp) return; // 再入荷通知アプリの要素がない場合は処理を終了

  // 再入荷通知モーダル内のバリアント選択を更新
  const updateVariantValue = () => {
    if(!targetVariant) return;
    const select = document.querySelector('#restock-product-variantId');
    const variantExists = select?.options && [...select.options].some(option => option.value === targetVariant);
    if(variantExists) select.value = targetVariant;
  }

  const restockNoticeButton = restockApp.querySelector('#_ngc_stock_notice_btn');
  if(restockNoticeButton) {
    // 再入荷通知モーダルを開くボタンが存在する場合は即座に発火
    restockNoticeButton.click();
    updateVariantValue();
  } else {
    // 再入荷通知モーダルを開くボタンが存在しない場合は生成後に発火
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        [...mutation.addedNodes].forEach(node => {
          if(node.nodeType === Node.ELEMENT_NODE && node.id === '_ngc_stock_notice_btn') {
            node.click();
            updateVariantValue();
            observer.disconnect(); // 監視を停止
          }
        });
      });
    });
    observer.observe(restockApp, { childList: true }); // 監視の開始
  }
});